import React, { useState } from "react";
import { ChoiceButton, PlayButton, shuffled } from "../../grammar/shared";
import { ArabicLine, Prompt } from "./shared";

/**
 * VerbFormItem — given a verb's past tense, pick its present / imperative /
 * maṣdar / active or passive participle. Data comes straight from the topic's
 * verb senses (no AI); choices shuffled per item.
 */
export default function VerbFormItem({ question, onAnswer, audio }) {
  const { data } = question;
  const [choices] = useState(() => shuffled(data.choices));
  const [picked, setPicked] = useState(null);

  const pick = (idx) => {
    if (picked !== null) return;
    setPicked(idx);
    onAnswer({ correct: choices[idx].form === data.correct_form, answer: choices[idx].form });
  };

  return (
    <>
      <Prompt>{question.prompt_en}</Prompt>
      <div className="flex items-center justify-center gap-3">
        <ArabicLine text={data.past} size="text-5xl" color="var(--gold-bright)" />
        {audio.audioAllowed && <PlayButton text={data.past} playingText={audio.playingText} onPlay={audio.play} />}
      </div>
      {data.past_transliteration && (
        <p className="text-sm text-center -mt-2 mb-3" style={{ color: "var(--parchment-dim)" }}>{data.past_transliteration}</p>
      )}
      <p dir="rtl" lang="ar" className="font-arabic text-xl text-center mb-4" style={{ color: "var(--tag-violet)" }}>{data.target_label_ar}</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2.5 max-w-xl mx-auto">
        {choices.map((c, idx) => {
          let state = "idle";
          if (picked !== null) {
            if (c.form === data.correct_form) state = "correct";
            else if (idx === picked) state = "wrong";
            else state = "dim";
          }
          return (
            <ChoiceButton key={c.form} arabic state={state} disabled={picked !== null} onClick={() => pick(idx)}>
              {c.text}
            </ChoiceButton>
          );
        })}
      </div>
    </>
  );
}
